import React from 'react';

import { useFetchSubmissionTaskNotes } from '../../../hooks/useFetchSubmissionTaskNotes';

import DatapharmTable from '@common/components/DatapharmTable/DatapharmTable';

import { prepareNotesTabColumns } from './helpers';

import { INotesQueryDependencies } from '@common/features/submission/types';

import { FileRoles } from '@common/features/document/types';

import * as Styled from './styles';

interface Props {
  submissionTaskId: string;
  notesQueryDependencies?: INotesQueryDependencies;
  showAttachmentsColumn: boolean;
  isTvtFeatureEnabled?: boolean;
  onFileDownload?: (noteId: number, fileRole?: FileRoles) => void;
}

export const NotesTab = ({ submissionTaskId, notesQueryDependencies, showAttachmentsColumn, isTvtFeatureEnabled, onFileDownload }: Props) => {
  const { data, isFetchingSubmissionTaskNotes } = useFetchSubmissionTaskNotes(submissionTaskId, notesQueryDependencies);

  const columns = prepareNotesTabColumns(showAttachmentsColumn, isTvtFeatureEnabled, onFileDownload);

  return (
    <Styled.DetailsTableWrapper>
      {data && (
        <DatapharmTable columns={columns} documents={data} showLoader={isFetchingSubmissionTaskNotes} data-testid="notes" />
      )}
    </Styled.DetailsTableWrapper>
  );
};
